const kebabToCamelCase = (name) => name
    .split("-")
    .map((part, index) => (index === 0 ? part.charAt(0).toUpperCase() + part.slice(1) : part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()))
    .join("");
export default kebabToCamelCase;
